import React, { FC, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { PredefinedMilisecondsTypeEnum } from '../../lib/enums';
import { RootState } from '../../lib/store';
import { getDefaultSelectableTradingPLanFromState } from '../../lib/store/crm/helpers';
import { CRMCall } from '../../lib/store/crm/types';
import { calculateTimeRemaining, isDateBeforeNow } from '../../lib/util/DateTimeHelpers';
import { isCallStatusReady } from '../../lib/util/error-handling/StatusByCallHelpers';

import { LatestNews } from '../../components';
import Leaderboard from '../Leaderboard/Leaderboard';
import Tournament from '../Tournament/Tournament';

import styles from './MyPosition.module.scss';

const MyPosition: FC<ReduxProps> = (props: ReduxProps): JSX.Element => {
  const { tradingPlan, isTradingPlanReady } = props;
  const { plans_accounts_activation: startDate } = tradingPlan;
  const isTournamentEnded = isDateBeforeNow(tradingPlan.plans_accounts_deactivation);
  const [isTournamentStarted, setTournamentStarted] = useState(false);

  useEffect(() => {
    if (!isTradingPlanReady || isTournamentEnded) {
      return;
    }
    calculateTimeRemaining(startDate, setTournamentStarted); // Initial calculation
    const intervalId = setInterval(() => {
      calculateTimeRemaining(startDate, setTournamentStarted);
    }, PredefinedMilisecondsTypeEnum.oneSecond);

    return () => clearInterval(intervalId); // eslint-disable-line consistent-return
  }, [startDate, isTradingPlanReady, isTournamentEnded]);

  return (
    <div className={styles.wrapperLayout}>
      <div className={styles.wrapperFirstSection}>
        <Tournament isTournamentStarted={isTournamentStarted} isTournamentEnded={isTournamentEnded} />
        <Leaderboard isTournamentStarted={isTournamentStarted} isTournamentEnded={isTournamentEnded} />
      </div>
      <div className={styles.wrapperSecondSection}>
        <LatestNews smallTitle />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  tradingPlan: getDefaultSelectableTradingPLanFromState(state.crm),
  isTradingPlanReady: isCallStatusReady(CRMCall.searchTradingPlans, state.crm.statusByCall),
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(MyPosition);
